export default class Validator {
    constructor() {
        this.defaultProperties();

        this.regexp_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    }

    defaultProperties() {
        this.errors = [];
    }

    clear() {
        this.defaultProperties();
    }

    hasError(name) {
        let has_error = this.errors.find(function(item) {
            return item.name === name;
        });

        return has_error !== undefined;
    }

    getErrorMessage(name) {
        let item = this.errors.find(function(item) {
            return item.name === name;
        });

        return item !== undefined ? item.message : false;
    }

    addError(name, message) {
        if(!message)
            message = null;

        this.errors.push({
            'name': name,
            'message': message
        });
    }

    validateEmail(email) {
        if(email)
            email = email.toLowerCase();

        return this.regexp_email.test(email);
    }
}
